import cta from "./call-to-action";

export default [
  {
    id: "what",
    title: "What We Do",
    content: [
      "We are a boutique software design and development consultancy with an extensive catalogue of skills.",
      "We leverage everything we’ve learned to craft beautiful products for our clients.",
      "We take you all the way from understanding your challenge through to delivery and beyond."
    ],
    cta
  },
  {
    id: "how",
    title: "How We Do It",
    content: [
      "The best digital products are created by hands-on, multidisciplinary teams of experts.",
      "We make sure the right skills are in the room and we inspire each other to bring out our most creative and considered thinking.",
      "We’re open to all technologies and pick the right tools for each job for flawless execution.",
      "We are Agile. No grand unveilings; prepare for less talk and more tangible progress. ",
      "We work smarter and automate the mindless, repeatable tasks on any project to free people up for work that requires true human intelligence and talent."
    ],
    cta
  },
  {
    id: "services",
    title: "Our Services",
    accordionContent: [
      {
        title: "Digital Development",
        content: [
          "We create scalable products that resonate with users and we get them to market quickly.  We’ll experiment, prototype, test and learn to gain confidence we’re building the right thing, whether that’s creating new products or enhancing existing ones.",
          "We’re open to all technologies. We pick the right tools for each job, drawing from our diverse pool of expert developers to ensure flawless execution. We use modern DevOps practices, infrastructure-as-code, continuous integration, and extensive automated testing to build platforms that are robust and easy to maintain in the long term. "
        ],
        image: "/images/home/development.jpg"
      },
      {
        title: "Digital Design",
        content: [
          "Join us on a journey of discovery and innovation. Creativity lies at the heart of every problem we solve, every product we deliver, every action we trigger.",
          "Your users’ needs are central to our efforts and we work hard to understand them to make engagement more purposeful, meaningful and immersive. Our design process is intensely collaborative, focussed on swift prototyping and continuous improvement. No grand unveilings, just effective progress. "
        ],
        image: "/images/home/design.jpg"
      },
      {
        title: "Data Engineering",
        content: [
          "Get the most out of your data. We make high-quality datasets available in an intuitive form to enhance business decision-making. We create scalable, exceptionally robust and reliable cloud-native data platforms, underpinned by modern engineering and DevOps practices. ",
          "When your data is spread across different sources with varying quality it slows down processes and decision-making, and ultimately ends with a poor user experience. We can unify data sources into a single platform, transforming your business operations. "
        ],
        image: "/images/home/engineering.jpg"
      },
      {
        title: "Process Engineering",
        content: [
          "We provide a range of tailored services to help you modernise and transform your working practices and engineering culture. ",
          "From advising on costs and assessing your engineering maturity and security, to senior agency team mentorship, learning and development, we make sure the right skills are in the room. "
        ],
        image: "/images/home/process.jpg"
      }
    ],
    cta
  },
  {
    id: "model",
    title: "Flip The In-House Model ",
    content: [
      "We give you all the benefits of a team that works for you full time, but in an agency setting.",
      "We attract and retain top talent because of the well understood agency career progression structure and dynamic atmosphere where team members can learn and grow, and switch teams and projects. ",
      "Work with us and you’ll work with some of the sharpest and most resourceful minds of your career. "
    ],
    cta
  }
];
